import { useSelector } from 'react-redux'
import type { LoginProgressState } from './types'
import type { State } from '../types'

export const useLoginProgress = (): LoginProgressState => {
  const loginProgress = useSelector((state: State) => state.loginProgress)
  return loginProgress
}
